import { apiClient } from "./client";

export interface SystemSettingItem {
  chiave: string;
  categoria: "email" | "odoo" | "sms" | "ritiri";
  descrizione: string;
  is_secret: boolean;
  is_set_in_db: boolean;
  is_set_in_env: boolean;
  /** Solo per campi non segreti già impostati — i secret non tornano mai in chiaro. */
  valore: string | null;
}

export async function listSettings(): Promise<{ settings: SystemSettingItem[] }> {
  const { data } = await apiClient.get<{ settings: SystemSettingItem[] }>("/settings");
  return data;
}

export async function updateSetting(chiave: string, valore: string): Promise<{ success: true }> {
  const { data } = await apiClient.patch<{ success: true }>(`/settings/${chiave}`, { valore });
  return data;
}

export async function resetSettingToEnv(chiave: string): Promise<{ success: true }> {
  const { data } = await apiClient.delete<{ success: true }>(`/settings/${chiave}`);
  return data;
}

export async function testConnection(
  categoria: "email" | "odoo" | "sms"
): Promise<{ success: boolean; error?: string }> {
  const { data } = await apiClient.post<{ success: boolean; error?: string }>(`/settings/test/${categoria}`);
  return data;
}
